import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=a1abd7a6"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=a1abd7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports